// NotFound.js
import React from "react";
import type { CSSProperties } from "react";

interface NotFoundProps {
  navigateWorkspace: (path: string) => void;
}

const NotFound: React.FC<NotFoundProps> = ({ navigateWorkspace }) => {
  const handleGoHome = () => {
    navigateWorkspace("/");
  };
  return (
    <div style={styles.container}>
      <div className="flex flex-col z-10 justify-center items-center h-full w-full">
        <div className="font-bold text-hx7 text-black">404</div>
        <div className=" text-hx3 text-black">
          La page que vous recherchez n'existe pas.
        </div>
        <div
          className="bg-black text-white rounded-full w-fit px-6 py-3 mt-6 cursor-pointer hover:bg-gray-800 transition duration-300"
          onClick={handleGoHome}
        >
          Retourner à l'accueil
        </div>
      </div>
      <div className="absolute top-0 left-0 w-full h-full z-0 ">
        <img
          src="https://products.ls.graphics/mesh-gradients/images/87.-Spacy.jpg"
          className="w-full h-full object-cover"
          alt="Background"
        />
      </div>
    </div>
  );
};

const styles: {
  container: CSSProperties;
  title: CSSProperties;
  message: CSSProperties;
  button: CSSProperties;
  buttonHover?: CSSProperties;
} = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    width: "100%",
    background: "linear-gradient(135deg, #4a57e3, #9e5df5)", // Gradient color
    color: "white",
    textAlign: "center",
  },
  title: {
    fontSize: "8rem",
    margin: "0",
  },
  message: {
    fontSize: "1.3rem",
    marginBottom: "2rem",
  },
  button: {
    padding: "1rem 2rem",
    fontSize: "1rem",
    color: "white",
    backgroundColor: "#ff00cc",
    border: "none",
    borderRadius: "30px",
    cursor: "pointer",
    transition: "background-color 0.3s",
  },
};

styles.buttonHover = {
  ...styles.button,
  backgroundColor: "#ff0099",
};

export default NotFound;
